import styled from 'styled-components';

export const Container = styled.div`
  .management-help-mark {
    font-size: 9px;
    height: 16px;
    width: 16px;
    font-weight: bold;
    text-align: center;
    margin-top: 1px;
    padding-top: 1px;
  }
`;
